import { useMemo } from 'react';
import type { LucideIcon } from 'lucide-react';
import { renderToStaticMarkup } from 'react-dom/server';
import useImage from 'use-image';

export const useLucideIconImage = (
  Icon: LucideIcon,
  size: number,
  color: string,
  strokeWidth = 2
) => {
  const dataUrl = useMemo(() => {
    const svg = renderToStaticMarkup(
      <Icon color={color} size={size} strokeWidth={strokeWidth} />
    );
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
  }, [Icon, color, size, strokeWidth]);

  const [image] = useImage(dataUrl);
  return image;
};
